import keyMirror from 'keymirror';

export default keyMirror({
  FETCH_COLLECTION_START   : null,
  FETCH_COLLECTION_SUCCESS : null,
  FETCH_COLLECTION_FAILURE : null,
  SET_CURRENT_COLLECTION   : null,
  LIST_COLLECTIONS_START   : null,
  LIST_COLLECTIONS_SUCCESS : null,
  LIST_COLLECTIONS_FAILURE : null
});



// WEBPACK FOOTER //
// banquet/constants/CollectionConstants.js